import React, { useState, useEffect } from 'react'
import { Table, DataTable, Pagination } from '@arnsbogroup/react-voicearchive'
import { useHistory } from 'react-router-dom'
import { FormattedDate, FormattedTime } from 'react-intl'
import useCurrentUser from 'hooks/useCurrentUser'

const Span = ({ children }) => <span>{ children }</span>
  
const CommentsIcon = ({ comments }) => (comments) ? <i className="text-yellow-500 fa fa-info" title={comments}></i> : null

const Deadline = ({ children }) => <span>
  <FormattedDate value={new Date(children * 1000)} /> <FormattedTime value={new Date(children * 1000)} />
</span>

const OpenOrders = ( {customer, onChange} ) => {
  if (!customer) {
    return null
  }

  const { features = [] } = useCurrentUser()
  const history = useHistory();

  const [orders, setOrders] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 20,
    pages: 0,
    total: 0
  });

  useEffect(() => {
    fetchOpenOrders();
  }, [customer]);

  const fetchOpenOrders = (page = 1) => {
    const params = new URLSearchParams({
      stages: [ // Listing all possible stages, except for CLOSED.  This means we are looking for open orders.
        'PENDING',
        'AMENDING',
        'READY',
        'IN_PROGRESS',
        'DRAFT',
      ],
      'customerId[]': customer.uid,
      page: page,
      pageSize: 20,
      orderBy: 'deadline',
      orderDirection: 'DESC',
      includeRelations: 1
    });

    fetch(`/rest/v2/order?${params}`)
      .then((response) => response.json())
      .then((data) => {
        setOrders(data.data);
        setPagination(data.meta);
      });
  };

  const onClick = (orderId) => {
    history.push(`/orders/${orderId}/overview`)
  }

  const getDeadlineStatus = (deadline) => {
    const diff = deadline - Math.floor(Date.now() / 1000);
    if(diff > 86400) {
      return <i className="inline-block rounded-full w-2 h-2 mr-2 bg-green-500" title="Deadline is not within the next 24 hours"></i>
    } else if (diff > 0) {
      return <i className="inline-block rounded-full w-2 h-2 mr-2 bg-yellow-500" title="Deadline is close!"></i>
    } else {
      return <i className="inline-block rounded-full w-2 h-2 mr-2 bg-red-600" title="Deadline has passed"></i>
    }
  }
  
  const DealLink = ({ children }) => (children) ? <a
    href={`https://my.voicearchive.com/crm/deal/details/${children}/`}
    target="_blank"
    onClick={(e) => e.stopPropagation()}
  >D{ children }</a> : null


  const DeadlineStatus = ({ deadline }) => <span>{getDeadlineStatus(deadline)}</span>

  function onPaginationChangeHandler(page) {
    fetchOpenOrders(page);
  }

  return (
    <div className='p-4'>
      {orders.length > 0 ? (
        <DataTable
          className="w-full"
          indicators={[
            CommentsIcon,
            DeadlineStatus,
          ]}
          components={{
          Tr: ({ childProps = {}, ...innerProps }) => {
              return (
              <Table.Tr className="cursor-pointer" onClick={childProps.uid ? () => onClick(childProps.uid) : undefined}
                  {...innerProps }
              />
              )
          },
          Td: Table.Td
          }}
          head={{
            name: { label: 'Name' },
            deal_id: { label: 'Deal ID' },
            deadline: { label: 'Deadline' },
          }}
          body={{
            name: Span,
            deal_id: DealLink,
            deadline: Deadline,
          }}
          entries={orders}
        />
      ) : (
        <div className="text-center text-gray-500">No open orders</div>
      )}

      <Pagination
        onChange={onPaginationChangeHandler}
        pageSize={pagination.pageSize}
        page={pagination.currentPage}
        totalItems={pagination.total}
      ></Pagination>
    </div>
  )
}

export default OpenOrders
